import { ReactNode } from "react";

import Box from "@mui/material/Box";

interface LoginLayoutProps {
  children: ReactNode;
}

export default function LoginLayout({ children }: LoginLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: "calc(100dvh - 100px)", // account for app bar height
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </Box>
  );
}
